import * as o from "react";
import e from "../lib/IconBase.es.js";
import n from "../defs/ShootingStar.es.js";
const t = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...r, weights: n }));
t.displayName = "ShootingStarIcon";
const c = t;
export {
  c as ShootingStar,
  t as ShootingStarIcon
};
